import camelCase from 'lodash/camelCase'
import { ButtonProps } from '@slite/components'
import { Button } from '..'
import { isString } from './Form'

export function FormButton({ children, ...props }: ButtonProps) {
  const dataTestId = isString(children) ? camelCase(children) : 'continue'
  return (
    <Button
      variant="primary"
      {...(props as ButtonProps)}
      data-test-id={dataTestId}
      type="submit"
    >
      {children}
    </Button>
  )
}
